mama-accordion {
  display: block;

  &.bg-theme {
    .mama-collapse {
      background-color: var(--theme-color-light, $mm-petrol-10);
    }
  }

  &.bg-theme-gray {
    .mama-collapse {
      background-color: $gray-100;
    }
  }

  &.bg-theme-gray,
  &.bg-theme {
    .mama-collapse {
      border-bottom: 0;
      margin-bottom: 0.4375rem;
      border-radius: 1rem;

      .collapse-headline {
        padding-left: 1.5rem;
        color: var(--theme-color, $mm-petrol);
      }

      .collapse-content {
        padding-left: 1.5rem;
        padding-right: 1.5rem;
      }
    }
  }

  .mama-collapse {
    display: block;
    width: 100%;
    border-bottom: 1px solid $mm-black-blue;

    .collapse-headline {
      cursor: pointer;
      position: relative;
      display: flex;
      font-weight: $font-weight-bolder;
      color: $body-color;
      padding: 1.5rem 4rem 1.25rem 0;
      font-size: $font-size-s;

      .plus {
        position: absolute;
        right: 1.25rem;
        top: calc(50% - 0.75rem);
        transition: $transition-ease-out;
        width: 1.5rem;
        height: 1.5rem;
      }
    }

    .collapse-content {
      padding-bottom: 1rem;
    }

    &[open] {
      .plus {
        transform: rotate(45deg);
      }
    }

    &:last-child {
      border-bottom: 0;
    }
  }
}
